import React, { useContext, useEffect, useState } from "react";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { useEngagementReport } from './store';
import { groupBy, map, get, isEmpty, size } from 'lodash';
import EngagementReportTable from './EngagementReportTable';
import { EngReportCont } from "./EngagementReport";

function EngagementTable({ props }) {
    const { setAgent, setTempAgents, setPage, page, setSortBy, applyFilter, slotBooking, attemptStatus } = props;
    const { engagementData, error, isLoading } = useEngagementReport();
    
    const [pageCount, setPageCount] = useState(1);
    const [slotPage, setSlotPage] = useState(1);
    const [filter, setFilter] = useState([]);
    const [slotPageCount, setSlotPageCount] = useState(1);
    const [groupedAgent, setGroupedAgent] = useState({});
    const [groupLocation, setGroupLocation] = useState({});
    const [groupProcess, setGroupProcess] = useState({});
    const [commonData, setCommonData] = useState([]);

    useEffect(()=>{
        setCommonData(engagementData?.engagements);
    },[engagementData])

    const { hourEngData, selectLead, selectLocation, selectProcess, filterOrder, setSelectLead, setSelectLocation, setSelectProcess, submitFlag, setSubmitFlag, pageSize } = useContext(EngReportCont);
    useEffect(() => {
        if (!isEmpty(attemptStatus) && slotBooking) {
            const engagement = commonData;
            const numOfSubarrays = Math.ceil((engagement?.length || 0) / pageSize) || 1;
            const paginatedEngagements = Array.from({ length: numOfSubarrays }, (_, i) => {
                const start = i * pageSize;
                return engagement.slice(start, start + pageSize);
            });

            setSlotPageCount(numOfSubarrays);
            setFilter(paginatedEngagements[slotPage - 1]);
        }
    }, [attemptStatus, slotPage,  commonData, pageSize]);

    useEffect(() => {
        if (!isEmpty(hourEngData) && slotBooking) {
            const groupedData = {
                agent: groupBy(hourEngData, "reporting_manager"),
                location: groupBy(hourEngData, "location"),
                process: groupBy(hourEngData, "process")
            };
            setGroupedAgent(groupedData.agent);
            setGroupLocation(groupedData.location);
            setGroupProcess(groupedData.process);
        } else {
            setGroupedAgent({});
            setGroupLocation({});
            setGroupProcess({});
        }
    }, [hourEngData]);



    useEffect(() => {
        const engagementsData = get(engagementData, 'engagements', []);
        if (attemptStatus && slotBooking && submitFlag &&  (!isEmpty(selectLead) || !isEmpty(selectLocation) || !isEmpty(selectProcess))) {
            let filteredData = [...engagementsData];
    
            filterOrder.forEach((filterType) => {
                if (filterType === 'lead' && !isEmpty(selectLead)) {
                    const agentMap = selectLead.flatMap(agent => groupedAgent[agent]?.map(group => group.user_id) || []);
                    filteredData = filteredData.filter(item => agentMap.includes(item.user_id));
                }
    
                if (filterType === 'location' && !isEmpty(selectLocation)) {
                    const locationMap = selectLocation.flatMap(location => groupLocation[location]?.map(group => group.user_id) || []);
                    filteredData = filteredData.filter(item => locationMap.includes(item.user_id));
                }
    
                if (filterType === 'process' && !isEmpty(selectProcess)) {
                    const processMap = selectProcess.flatMap(process => groupProcess[process]?.map(group => group.user_id) || []);
                    filteredData = filteredData.filter(item => processMap.includes(item.user_id));
                }
            });

            setCommonData(filteredData); 
        } else {
            setSelectLead([]);
            setSelectLocation([]);
            setSelectProcess([]);
            setCommonData([...engagementsData]);
        }
    }, [submitFlag]);
    

    useEffect(() => {
        const agents = get(engagementData, 'reps', []);
        const tempAgents = get(engagementData, 'tempReps', []);
        const numberOfPages = get(engagementData, 'pageCount', 1);

        if (agents) {
            setAgent(agents);
            setTempAgents(tempAgents);
            setPageCount(numberOfPages);
        }
    }, [engagementData]);

    return (
        <>
        {!isEmpty(attemptStatus) && <div className="text-end p-1">Engagement Count : {size(commonData)}</div>}
            <EngagementReportTable
                filterData={!isEmpty(attemptStatus)? filter  :engagementData?.engagements}
                isLoading={isLoading}
                error={error}
                activeTab={"slot_booking_total"}
                setSortBy={setSortBy}
                applyFilter={applyFilter}
                tab={props.activeTab}
            />
            {pageCount ? (
                <PaginationDiv
                    newPage={(page) => {
                        !isEmpty(attemptStatus)? setSlotPage(page) :setPage(page)
                    }}
                    paginationData={{ pageCount:  !isEmpty(attemptStatus) ? slotPageCount : pageCount, page: !isEmpty(attemptStatus) ? slotPage : page }}
                />
            ) : (
                <></>
            )}
        </>
    );
}

export default EngagementTable;
